(function () {
  var root = document.getElementById("etk");
  if (!root) return;

  var HANDLE_PREFIX = "kaitorilist";
  var PRICE_BASE_URL = "https://price-base.com/useful/go-pricebase2";
  var MOETAKU_URL = "https://benefit-new-business.com/go-2moetaku";
  var state = {
    rarity: "all",
    sort: "desc",
    query: ""
  };

  var TITLES = [
    {
      slug: "opc",
      code: "OP",
      name: "ワンピースカードゲーム",
      shortName: "ワンピースカード",
      description: "収録パック別の参考相場（目安価格）一覧",
      updated: window.OPC_UPDATED || "",
      base: window.OPC_BASE || "",
      packs: window.OPC_PACKS || [],
      filters: [
        { value: "all", label: "すべて" },
        { value: "SEC", label: "SEC" },
        { value: "SR", label: "SR" },
        { value: "R", label: "R" },
        { value: "L", label: "L（リーダー）" },
        { value: "SP", label: "SP" },
        { value: "P", label: "パラレル" }
      ]
    },
    {
      slug: "dbfw",
      code: "DBFW",
      name: "ドラゴンボールスーパーカードゲーム フュージョンワールド",
      shortName: "フュージョンワールド",
      description: "高額カードと収録パック別の参考相場（目安）一覧",
      updated: window.FW_UPDATED || "",
      base: window.FW_BASE || "",
      packs: window.FW_PACKS || [],
      filters: [
        { value: "all", label: "すべて" },
        { value: "SCR", label: "SCR" },
        { value: "SR", label: "SR" },
        { value: "R", label: "R" },
        { value: "L", label: "L（リーダー）" },
        { value: "UC", label: "UC" },
        { value: "C", label: "C" },
        { value: "P", label: "パラレル" }
      ]
    },
    {
      slug: "dbh",
      code: "DBH",
      name: "ドラゴンボールヒーローズ",
      shortName: "ドラゴンボールヒーローズ",
      description: "高額カードと弾別の参考相場（目安）一覧",
      updated: window.DBH_UPDATED || "",
      base: window.DBH_BASE || "",
      packs: window.DBH_PACKS || [],
      filters: [
        { value: "all", label: "すべて" },
        { value: "UR", label: "UR" },
        { value: "SEC", label: "SEC" },
        { value: "P", label: "P / パラレル" },
        { value: "SR", label: "SR" },
        { value: "CP", label: "CP" },
        { value: "R", label: "R" },
        { value: "C", label: "C" }
      ]
    },
    {
      slug: "nivelarena",
      code: "NIVEL ARENA",
      name: "NIVEL ARENA（ニベルアリーナ）",
      shortName: "ニベルアリーナ",
      description: "高額カードと収録パック別の参考相場（目安）一覧",
      updated: window.NA_UPDATED || "",
      base: window.NA_BASE || "",
      packs: window.NA_PACKS || [],
      filters: [
        { value: "all", label: "すべて" },
        { value: "SPR", label: "SPR" },
        { value: "SPL", label: "SPL" },
        { value: "UR", label: "UR" },
        { value: "L", label: "L" },
        { value: "SR", label: "SR" },
        { value: "R", label: "R" },
        { value: "P", label: "P" }
      ]
    },
    {
      slug: "conan",
      code: "CONAN",
      name: "名探偵コナンカードゲーム",
      shortName: "コナンカード",
      description: "高額カードと収録パック別の参考買取相場一覧",
      updated: window.CONAN_UPDATED || "",
      base: window.CONAN_BASE || "",
      packs: window.CONAN_PACKS || [],
      filters: [
        { value: "all", label: "すべて" },
        { value: "SEC", label: "SEC" },
        { value: "MRP", label: "MRP" },
        { value: "SRP", label: "SRP" },
        { value: "SR", label: "SR" },
        { value: "MR", label: "MR" },
        { value: "RP", label: "RP" },
        { value: "CP", label: "CP" },
        { value: "R", label: "R" }
      ]
    },
    {
      slug: "lorcana",
      code: "LORCANA",
      name: "ディズニー・ロルカナ・TCG",
      shortName: "ロルカナ",
      description: "高額カードと収録パック別の参考買取相場一覧",
      updated: window.LORCANA_UPDATED || "",
      base: window.LORCANA_BASE || "",
      packs: window.LORCANA_PACKS || [],
      filters: [
        { value: "all", label: "すべて" },
        { value: "アイコニック", label: "アイコニック" },
        { value: "エンチャンテッド", label: "エンチャンテッド" },
        { value: "レジェンダリー", label: "レジェンダリー" },
        { value: "スーパーレア", label: "スーパーレア" },
        { value: "レア", label: "レア" },
        { value: "プロモ", label: "プロモ" }
      ]
    },
    {
      slug: "pokemon",
      code: "POKEMON",
      name: "ポケモンカードゲーム",
      shortName: "ポケカ",
      description: "高額カードと収録パック別の参考買取相場一覧",
      updated: window.POKEMON_UPDATED || "",
      base: window.POKEMON_BASE || "",
      packs: window.POKEMON_PACKS || [],
      filters: [
        { value: "all", label: "すべて" },
        { value: "MUR", label: "MUR" },
        { value: "SAR", label: "SAR" },
        { value: "UR", label: "UR" },
        { value: "SR", label: "SR" },
        { value: "AR", label: "AR" },
        { value: "SSR", label: "SSR" },
        { value: "HR", label: "HR" },
        { value: "RR", label: "RR" },
        { value: "P", label: "プロモ" }
      ]
    }
  ];

  function topUrl() {
    return "/pages/" + HANDLE_PREFIX;
  }

  function titleUrl(titleItem) {
    return "/pages/" + HANDLE_PREFIX + "-" + titleItem.slug;
  }

  function packUrl(titleItem, packSlug) {
    return "/pages/" + HANDLE_PREFIX + "-" + titleItem.slug + "-" + packSlug;
  }

  function normalizePackSlug(titleItem, packSlug) {
    if (!titleItem || !packSlug) return packSlug;

    if (titleItem.slug === "opc" && packSlug === "high-price") {
      return "kogaku";
    }

    return packSlug;
  }

  function currentHandle() {
    return root.getAttribute("data-handle") || "";
  }

  function parseHandle() {
    var handle = currentHandle();
    if (handle === HANDLE_PREFIX) {
      return { level: "l1" };
    }

    if (handle.indexOf(HANDLE_PREFIX + "-") !== 0) {
      return { level: "404" };
    }

    var remainder = handle.slice((HANDLE_PREFIX + "-").length);
    for (var i = 0; i < TITLES.length; i += 1) {
      var titleItem = TITLES[i];
      if (remainder === titleItem.slug) {
        return { level: "l2", title: titleItem };
      }
      if (remainder.indexOf(titleItem.slug + "-") === 0) {
        return {
          level: "l3",
          title: titleItem,
          packSlug: remainder.slice((titleItem.slug + "-").length)
        };
      }
    }

    return { level: "404" };
  }

  function yen(value) {
    return "¥" + Number(value).toLocaleString("ja-JP");
  }

  function isHighPricePack(pack) {
    return !!(pack && (pack.slug === "high-price" || pack.slug === "kogaku"));
  }

  function packLabel(pack) {
    return pack.n + (pack.code ? "【" + pack.code + "】" : "");
  }

  function highPriceHeading(titleItem) {
    return (titleItem.shortName || titleItem.name) + "の高額カード買取相場目安表";
  }

  function titleBySlug(slug) {
    for (var i = 0; i < TITLES.length; i += 1) {
      if (TITLES[i].slug === slug) return TITLES[i];
    }
    return null;
  }

  function numericPriceValue(value) {
    if (typeof value === "number" && Number.isFinite(value)) return value;
    if (typeof value !== "string") return null;
    var cleaned = value.replace(/[￥¥,]/g, "").trim();
    if (!/^\d+$/.test(cleaned)) return null;
    return Number(cleaned);
  }

  function imageUrlFor(titleItem, imageRef) {
    if (!imageRef) return "";
    if (/^https?:\/\//.test(imageRef)) return imageRef;
    return String(titleItem.base || "") + imageRef;
  }

  function rarityMatches(filter, rarity) {
    if (filter === "all") return true;
    if (filter === "P") {
      return rarity.indexOf("/P") >= 0 ||
        rarity.indexOf("-P") >= 0 ||
        rarity.indexOf("パラレル") >= 0 ||
        rarity.indexOf("★") >= 0 ||
        rarity.indexOf("☆") >= 0;
    }
    return rarity.indexOf(filter) === 0;
  }

  function filterOptionsFor(titleItem) {
    return titleItem.filters || [
      { value: "all", label: "すべて" },
      { value: "SEC", label: "SEC" },
      { value: "SR", label: "SR" },
      { value: "R", label: "R" },
      { value: "L", label: "L（リーダー）" },
      { value: "SP", label: "SP" },
      { value: "P", label: "パラレル" }
    ];
  }

  function setDescription(description) {
    var meta = document.querySelector('meta[name="description"]');
    if (meta) meta.setAttribute("content", description);
  }

  function setBreadcrumbJsonLd(items) {
    var el = document.getElementById("ka-breadcrumb-jsonld");
    if (!el) {
      el = document.createElement("script");
      el.id = "ka-breadcrumb-jsonld";
      el.type = "application/ld+json";
      document.head.appendChild(el);
    }

    el.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: items.map(function (item, index) {
        return {
          "@type": "ListItem",
          position: index + 1,
          name: item.name,
          item: item.url
        };
      })
    });
  }

  function pageShell(opts) {
    document.title = opts.title;
    setDescription(opts.description);

    root.innerHTML = [
      '<div class="ka-page">',
      '<section class="ka-hero">',
      '<div class="ka-wrap">',
      '<div class="ka-breadcrumbs">' + opts.breadcrumbs + "</div>",
      "<h1>" + opts.heroTitle + "</h1>",
      opts.heroLead ? '<p class="ka-lead">' + opts.heroLead + "</p>" : "",
      '<div class="ka-updated">相場情報 最終更新：<b>' + (opts.updated || "") + "</b></div>",
      "</div>",
      "</section>",
      opts.stickyTabs || "",
      '<main class="ka-main">' + opts.body + "</main>",
      '<button class="ka-to-top" id="ka-to-top" type="button" aria-label="ページ上部へ戻る"><span>↑</span>上へ</button>',
      '<a class="ka-followbar" href="' + PRICE_BASE_URL + '" target="_blank" rel="nofollow sponsored noopener noreferrer">PRICE BASEで無料査定する <span>↗</span></a>',
      "</div>"
    ].join("");

    bindBackToTop();
  }

  function bindBackToTop() {
    var button = document.getElementById("ka-to-top");
    if (!button) return;

    function updateVisibility() {
      button.classList.toggle("is-visible", (window.scrollY || 0) > 360);
    }

    button.addEventListener("click", function () {
      window.scrollTo({ top: 0, behavior: "smooth" });
    });
    updateVisibility();
    window.addEventListener("scroll", updateVisibility, { passive: true });
  }

  function noticeBlock() {
    return [
      '<div class="ka-notice">',
      '<div class="ka-notice-head"><span class="ka-notice-icon">!</span>注意点</div>',
      "<p>本ページの価格・相場情報は、複数の公開情報をもとに ETERNIS が独自に整理した参考目安です。実際の買取価格や査定額、取引価格を保証するものではなく、カードの状態、市場動向、在庫状況、時期、各店舗・各サービスの基準によって変動します。最新の査定額や取引条件は、各サービス・各店舗の案内をご確認ください。なお、ETERNIS は本ページ上で買取サービスを提供していません。</p>",
      "</div>"
    ].join("");
  }

  function sectionHeading(label, meta) {
    return [
      '<h2 class="ka-section-head">',
      '<span class="ka-section-heading-text">' + label + "</span>",
      meta ? '<span class="ka-section-meta">' + meta + "</span>" : "",
      "</h2>"
    ].join("");
  }

  function promoBlock(label, headingTag) {
    var tag = headingTag || "h2";
    return [
      '<div class="ka-promo">',
      '<div class="ka-promo-top">',
      '<div class="ka-promo-flag">Sponsored （別サービス）</div>',
      "<" + tag + ">" + label + 'を売るなら <span>PRICE BASE</span></' + tag + ">",
      "<p>宅配買取サービス「PRICE BASE」なら、気になるカードをまとめて査定・申込できます。発送料無料・査定料無料で、自宅からそのまま発送するだけです。</p>",
      '<a class="ka-primary-button" href="' + PRICE_BASE_URL + '" target="_blank" rel="nofollow sponsored noopener noreferrer">PRICE BASE で買取を申し込む <span>↗</span></a>',
      '<div class="ka-promo-note">※ PRICE BASE は ETERNIS とは別の買取サービスです。買取の申込・査定・取引は PRICE BASE 上で行われます。</div>',
      "</div>",
      "</div>"
    ].join("");
  }

  function moetakuPromoBlock(label, headingTag) {
    var tag = headingTag || "h2";
    return [
      '<div class="ka-promo">',
      '<div class="ka-promo-top">',
      '<div class="ka-promo-flag">Sponsored （別サービス）</div>',
      "<" + tag + ">" + label + 'をまとめて宅配買取に出したい人は <span>もえたく</span> もチェック</' + tag + ">",
      "<p>トレカやホビー商品をまとめて宅配買取に出したい場合や、買取サービスの選択肢を広げたい場合は「もえたく」もおすすめです。送料無料で申し込めるため、宅配買取を比較したいときにチェックしやすいです。</p>",
      '<a class="ka-primary-button" href="' + MOETAKU_URL + '" target="_blank" rel="nofollow sponsored noopener noreferrer">もえたく 公式サイトをチェックする <span>↗</span></a>',
      '<div class="ka-promo-note">※ もえたく は ETERNIS とは別の買取サービスです。買取の申込・査定・取引は もえたく 上で行われます。</div>',
      "</div>",
      "</div>"
    ].join("");
  }

  function extraPromoBlock(label, headingTag) {
    return moetakuPromoBlock(label, headingTag || "h2");
  }

  function topView() {
    var titleCards = TITLES.map(function (item) {
      return [
        '<a class="ka-card-link" href="' + titleUrl(item) + '">',
        '<div class="ka-card-body">',
        '<div class="ka-card-tags"><span class="ka-card-tag">カードタイプ</span><span class="ka-card-chip">' + item.code + "</span></div>",
        '<div class="ka-card-title">' + item.name + "</div>",
        '<div class="ka-card-meta">収録パック ' + item.packs.length + " ・ 最終更新 " + (item.updated || "") + "</div>",
        '<span class="ka-card-cta">買取相場を見る</span>',
        "</div>",
        "</a>"
      ].join("");
    }).join("");

    var latest = TITLES.map(function (item) { return item.updated; }).filter(Boolean).sort().slice(-1)[0] || "";

    pageShell({
      title: "トレカ買取相場目安価格表｜ETERNIS",
      description: "トレカの買取相場目安価格表。タイトル別・収録パック別に参考相場を一覧で確認できます。",
      breadcrumbs: '<a href="' + topUrl() + '">買取相場ガイド</a>',
      heroEyebrow: "Market Price",
      heroTitle: "トレカ買取相場表 目安価格",
      heroLead: "複数のサイトを参考に独自に調査してまとめた、タイトル別の相場の目安です。気になるタイトルを選ぶと、収録パックや弾ごとのカード相場一覧へ進めます。",
      updated: latest,
      body: [
        '<div class="ka-wrap">',
        noticeBlock(),
        sectionHeading("取り扱いタイトル", TITLES.length + "タイトル"),
        '<div class="ka-grid ka-grid-titles">' + titleCards + "</div>",
        promoBlock("カード", "h2"),
        extraPromoBlock("トレカ", "h2"),
        '<div class="ka-page-foot">表示価格は独自調査に基づく相場の目安であり、買取金額を提示・保証するものではありません。ETERNIS は買取を行っていません。</div>',
        "</div>"
      ].join("")
    });

    setBreadcrumbJsonLd([
      { name: "買取相場ガイド", url: window.location.origin + topUrl() }
    ]);
  }

  function titleView(titleItem) {
    var listLabel = titleItem.slug === "dbh" ? "収録弾一覧" : "収録パック一覧";
    var listCountLabel = titleItem.packs.length + (titleItem.slug === "dbh" ? "弾" : "パック");
    var descriptionLabel = titleItem.slug === "dbh" ? "弾別" : "収録パック別";
    var heroLeadLabel = titleItem.slug === "dbh" ? "弾別" : "収録パック別";
    var cards = titleItem.packs.map(function (pack) {
      return [
        '<a class="ka-pack-link" href="' + packUrl(titleItem, pack.slug) + '">',
        '<div class="ka-pack-body">',
        pack.code ? '<span class="ka-pack-code">' + pack.code + "</span>" : "",
        '<div class="ka-pack-title">' + pack.n + "</div>",
        '<div class="ka-pack-meta">掲載 ' + pack.c.length + "種 ・ 最終更新 " + (titleItem.updated || "") + "</div>",
        '<span class="ka-pack-cta">買取相場表を見る</span>',
        "</div>",
        "</a>"
      ].join("");
    }).join("");
    var fullTables = (titleItem.slug === "opc" || titleItem.slug === "dbfw" || titleItem.slug === "dbh" || titleItem.slug === "nivelarena" || titleItem.slug === "conan" || titleItem.slug === "lorcana" || titleItem.slug === "pokemon") ? allPackTables(titleItem) : "";

    pageShell({
      title: titleItem.name + "の買取目安相場価格表｜ETERNIS",
      description: titleItem.name + "の" + descriptionLabel + " 買取目安相場表の一覧。価格は ETERNIS の独自調査による目安です。",
      breadcrumbs: '<a href="' + topUrl() + '">買取相場ガイド</a> ／ ' + titleItem.name,
      heroEyebrow: "Market Price ・ " + titleItem.name,
      heroTitle: titleItem.name + "<small>" + titleItem.description + "</small>",
      heroLead: (titleItem.shortName || titleItem.name) + "の高額カードと" + heroLeadLabel + "の参考買取相場を掲載しています。",
      updated: titleItem.updated || "",
      body: [
        '<div class="ka-wrap">',
        noticeBlock(),
        fullTables,
        sectionHeading(listLabel, listCountLabel),
        '<div class="ka-grid ka-grid-packs">' + cards + "</div>",
        promoBlock(titleItem.name, "h2"),
        extraPromoBlock(titleItem.shortName || titleItem.name, "h2"),
        '<a class="ka-back-link" href="' + topUrl() + '">トレカ買取目安相場表 TOP</a>',
        '<div class="ka-page-foot">表示価格は独自調査に基づく相場の目安であり、買取金額を提示・保証するものではありません。ETERNIS は買取を行っていません。</div>',
        "</div>"
      ].join("")
    });

    setBreadcrumbJsonLd([
      { name: "買取相場ガイド", url: window.location.origin + topUrl() },
      { name: titleItem.name, url: window.location.origin + titleUrl(titleItem) }
    ]);
  }

  function renderPackCards(titleItem, pack) {
    var area = document.getElementById("ka-card-area");
    var count = document.getElementById("ka-card-count");
    if (!area || !count) return;

    var filtered = pack.c.filter(function (card) {
      var no = card[0];
      var name = card[1];
      var rarity = String(card[2] || "");
      var query = state.query.trim().toLowerCase();
      var textMatch = query === "" ||
        String(no || "").toLowerCase().indexOf(query) >= 0 ||
        String(name || "").toLowerCase().indexOf(query) >= 0;
      return textMatch && rarityMatches(state.rarity, rarity);
    });

    filtered.sort(function (a, b) {
      var pa = numericPriceValue(a[3]);
      var pb = numericPriceValue(b[3]);
      if (pa == null && pb == null) return 0;
      if (pa == null) return 1;
      if (pb == null) return -1;
      return state.sort === "asc" ? pa - pb : pb - pa;
    });

    count.textContent = filtered.length + " 種";
    if (!filtered.length) {
      area.innerHTML = '<div class="ka-empty">該当するカードがありません。</div>';
      return;
    }

    area.innerHTML = filtered.map(function (card) {
      return priceCardMarkup(titleItem, card);
    }).join("");
  }

  function priceCardMarkup(titleItem, card) {
    var no = card[0];
    var name = card[1];
    var rarity = card[2];
    var price = card[3];
    var imageRef = card[4];
    var imageUrl = imageUrlFor(titleItem, imageRef);
    var numericPrice = numericPriceValue(price);
    var thumb = imageUrl
      ? '<div class="ka-thumb"><img src="' + imageUrl + '" alt="' + name + " " + no + '" loading="lazy"></div>'
      : '<div class="ka-thumb is-placeholder">CARD<br>IMG</div>';
    var priceMarkup = "";

    if (price == null) {
      priceMarkup = '<div class="ka-price-tbd">相場確認中</div>';
    } else if (numericPrice == null) {
      priceMarkup = '<div class="ka-price-label">参考買取状況</div><div class="ka-price-value is-text">' + price + "</div>";
    } else {
      priceMarkup = '<div class="ka-price-label">参考買取相場</div><div class="ka-price-value">' + yen(numericPrice) + "<small>前後</small></div>";
    }

    return [
      '<div class="ka-price-card">',
      thumb,
      '<div class="ka-price-info">',
      '<div class="ka-card-no">' + (no || "&nbsp;") + "</div>",
      '<div class="ka-card-name">' + name + "</div>",
      '<div class="ka-rarity">' + (rarity || "-") + "</div>",
      '<div class="ka-price-block">' + priceMarkup + "</div>",
      "</div>",
      "</div>"
    ].join("");
  }

  function cardsByPrice(cards) {
    return cards.slice().sort(function (a, b) {
      var pa = numericPriceValue(a[3]);
      var pb = numericPriceValue(b[3]);
      if (pa == null && pb == null) return 0;
      if (pa == null) return 1;
      if (pb == null) return -1;
      return pb - pa;
    });
  }

  function allPackTables(titleItem) {
    var isDbh = titleItem.slug === "dbh";
    var unitLabel = isDbh ? "弾" : "パック";
    var tableLabel = (titleItem.shortName || titleItem.name) + "の買取相場表";
    var total = titleItem.packs.reduce(function (count, pack) {
      return count + pack.c.length;
    }, 0);
    var jumpLinks = titleItem.packs.map(function (pack) {
      return '<a href="#ka-pack-' + pack.slug + '">' + packLabel(pack) + '<span>相場表を見る</span></a>';
    }).join("");
    var sections = titleItem.packs.map(function (pack) {
      var label = isHighPricePack(pack)
        ? highPriceHeading(titleItem)
        : packLabel(pack) + "の買取相場表";
      var cards = cardsByPrice(pack.c).map(function (card) {
        return priceCardMarkup(titleItem, card);
      }).join("");

      return [
        '<section class="ka-all-pack-section" id="ka-pack-' + pack.slug + '">',
        '<div class="ka-all-pack-heading">',
        '<div>',
        '<h2>' + label + "</h2>",
        '<p>掲載 ' + pack.c.length + "種</p>",
        "</div>",
        '<a href="' + packUrl(titleItem, pack.slug) + '">個別ページを見る</a>',
        "</div>",
        '<div class="ka-grid ka-grid-cards ka-all-pack-cards">' + cards + "</div>",
        "</section>"
      ].join("");
    }).join("");

    return [
      sectionHeading(tableLabel, total + "種"),
      '<div class="ka-all-pack-intro">収録' + unitLabel + 'ごとのカード買取相場を、上から順に確認できます。</div>',
      '<nav class="ka-all-pack-jump" aria-label="収録' + unitLabel + 'の買取相場表">' + jumpLinks + "</nav>",
      sections
    ].join("");
  }

  function renderPackMeta(titleItem, pack) {
    var label = packLabel(pack);
    var titleText = isHighPricePack(pack)
      ? highPriceHeading(titleItem)
      : label + "の買取目安相場価格表";
    var descriptionText = isHighPricePack(pack)
      ? titleItem.name + "の高額カードの買取目安相場一覧。参考相場（目安）をまとめています。"
      : titleItem.name + "「" + label + "」の買取目安相場一覧。収録カードの参考相場（目安）をまとめています。";
    document.title = titleText + "【" + titleItem.name + "】｜ETERNIS";
    setDescription(descriptionText);
    document.getElementById("ka-pack-label").textContent = label;
    document.getElementById("ka-pack-title").innerHTML = isHighPricePack(pack)
      ? highPriceHeading(titleItem)
      : label + "<small>" + titleItem.name + " 買取目安相場表</small>";

    setBreadcrumbJsonLd([
      { name: "買取相場ガイド", url: window.location.origin + topUrl() },
      { name: titleItem.name, url: window.location.origin + titleUrl(titleItem) },
      { name: label, url: window.location.origin + packUrl(titleItem, pack.slug) }
    ]);
  }

  function bindPackInteractions(titleItem, pack) {
    var searchInput = document.getElementById("ka-search-input");
    var chips = Array.prototype.slice.call(document.querySelectorAll(".ka-chip"));
    var sortButtons = Array.prototype.slice.call(document.querySelectorAll(".ka-sort-segment button"));

    if (searchInput) {
      searchInput.addEventListener("input", function () {
        state.query = searchInput.value;
        renderPackCards(titleItem, pack);
      });
    }

    chips.forEach(function (chip) {
      chip.addEventListener("click", function () {
        state.rarity = chip.getAttribute("data-rarity") || "all";
        chips.forEach(function (item) {
          item.classList.toggle("is-active", item === chip);
        });
        renderPackCards(titleItem, pack);
      });
    });

    sortButtons.forEach(function (button) {
      button.addEventListener("click", function () {
        state.sort = button.getAttribute("data-sort") || "desc";
        sortButtons.forEach(function (item) {
          item.classList.toggle("is-active", item === button);
        });
        renderPackCards(titleItem, pack);
      });
    });
  }

  function packView(titleItem, packSlug) {
    packSlug = normalizePackSlug(titleItem, packSlug);

    var pack = null;
    for (var i = 0; i < titleItem.packs.length; i += 1) {
      if (titleItem.packs[i].slug === packSlug) {
        pack = titleItem.packs[i];
        break;
      }
    }
    if (!pack) {
      notFoundView();
      return;
    }

    state.query = "";
    state.rarity = "all";
    state.sort = "desc";

    var highPricePage = isHighPricePack(pack);
    var packLabelText = packLabel(pack);
    var filterHeadingLabel = highPricePage
      ? "高額カードの検索・絞り込み"
      : packLabelText + "のカード検索・絞り込み";
    var listHeadingLabel = highPricePage
      ? highPriceHeading(titleItem)
      : packLabelText + "の買取相場目安表";
    var moreHeadingLabel = titleItem.slug === "dbh"
      ? (highPricePage ? titleItem.name + "の各収録弾の買取目安相場" : titleItem.name + "の他の収録弾の買取目安相場")
      : (highPricePage ? titleItem.name + "の各収録パック買取目安相場" : titleItem.name + "の他の収録パック買取目安相場");
    var pageTitle = highPricePage
      ? highPriceHeading(titleItem) + "【" + titleItem.name + "】｜ETERNIS"
      : packLabelText + "の買取目安相場価格表【" + titleItem.name + "】｜ETERNIS";
    var pageDescription = highPricePage
      ? titleItem.name + "の高額カードの買取目安相場一覧。参考相場（目安）をまとめています。"
      : titleItem.name + "「" + packLabelText + "」の買取目安相場一覧。収録カードの参考相場（目安）をまとめています。";
    var heroLeadText = highPricePage
      ? (titleItem.shortName || titleItem.name) + "の高額カードを価格順で一覧化しています。売りたいカードの相場目安を確認したいときにご活用ください。"
      : (titleItem.shortName || titleItem.name) + "「" + pack.n + "」に収録されるカードの参考相場（目安）を一覧化しています。売りたいカードの価格目安を確認したいときに、ぜひご活用ください。";
    var filterOptions = filterOptionsFor(titleItem);
    var tabs = titleItem.packs.map(function (entry) {
      return [
        '<a class="ka-pack-tab' + (entry.slug === pack.slug ? " is-active" : "") + '" href="' + packUrl(titleItem, entry.slug) + '">',
        entry.n,
        "<span>" + (entry.code ? entry.code + " ・ " : "") + entry.c.length + "種</span>",
        "</a>"
      ].join("");
    }).join("");

    var moreLinks = titleItem.packs.filter(function (entry) {
      return entry.slug !== pack.slug;
    }).map(function (entry) {
      return '<a href="' + packUrl(titleItem, entry.slug) + '">' + entry.n + "<span>" + (entry.code || "") + "</span></a>";
    }).join("");

    var filterButtons = filterOptions.map(function (option) {
      return '<button class="ka-chip' + (option.value === "all" ? " is-active" : "") + '" type="button" data-rarity="' + option.value + '">' + option.label + "</button>";
    }).join("");

    pageShell({
      title: pageTitle,
      description: pageDescription,
      breadcrumbs: '<a href="' + topUrl() + '">買取相場ガイド</a> ／ <a href="' + titleUrl(titleItem) + '">' + titleItem.name + '</a> ／ <span id="ka-pack-label">' + packLabelText + "</span>",
      heroEyebrow: highPricePage ? "" : "Market Price ・ " + titleItem.name,
      heroTitle: highPricePage
        ? '<span id="ka-pack-title">' + highPriceHeading(titleItem) + "</span>"
        : '<span id="ka-pack-title">' + packLabelText + "<small>" + titleItem.name + " 買取目安相場表</small></span>",
      heroLead: heroLeadText,
      updated: titleItem.updated || "",
      stickyTabs: '<div class="ka-pack-tabs"><div class="ka-pack-tabs-inner">' + tabs + "</div></div>",
      body: [
        '<div class="ka-wrap">',
        noticeBlock(),
        '<section class="ka-filter" aria-labelledby="ka-filter-heading">',
        '<h2 class="ka-filter-head" id="ka-filter-heading">' + filterHeadingLabel + "</h2>",
        '<div class="ka-filter-label">カード名・型番で検索</div>',
        '<div class="ka-search"><span>🔍</span><input id="ka-search-input" type="text" placeholder="カード名・型番で検索"></div>',
        '<div class="ka-filter-label">レアリティ</div>',
        '<div class="ka-chip-row">' + filterButtons + "</div>",
        "</section>",
        '<section class="ka-list-section" aria-labelledby="ka-card-list-heading">',
        '<h2 class="ka-list-head" id="ka-card-list-heading">' + listHeadingLabel + "</h2>",
        '<div class="ka-list-bar"><span class="ka-list-count" id="ka-card-count"></span>',
        '<div class="ka-sort"><span class="ka-sort-label">並び替え</span>',
        '<div class="ka-sort-segment"><button class="is-active" type="button" data-sort="desc">高い順</button><button type="button" data-sort="asc">安い順</button></div>',
        "</div></div>",
        '<div class="ka-grid ka-grid-cards" id="ka-card-area"></div>',
        "</section>",
        '<section class="ka-more" aria-labelledby="ka-more-heading"><h2 class="ka-more-head" id="ka-more-heading">' + moreHeadingLabel + "</h2>",
        '<div class="ka-more-links">' + moreLinks + "</div>",
        '<div class="ka-more-foot"><a class="ka-back-link" href="' + titleUrl(titleItem) + '">' + (titleItem.shortName || titleItem.name) + ' 買取目安相場表 TOP</a>',
        '<a class="ka-back-link" href="' + topUrl() + '">トレカ買取目安相場 TOP</a></div></section>',
        promoBlock(titleItem.name, "h2"),
        extraPromoBlock(titleItem.shortName || titleItem.name, "h2"),
        '<div class="ka-page-foot">表示価格は独自調査に基づく相場の目安であり、買取金額を提示・保証するものではありません。ETERNIS は買取を行っていません。</div>',
        "</div>"
      ].join("")
    });

    renderPackMeta(titleItem, pack);
    renderPackCards(titleItem, pack);
    bindPackInteractions(titleItem, pack);
  }

  function notFoundView() {
    pageShell({
      title: "ページが見つかりません｜ETERNIS",
      description: "指定された買取相場ページは見つかりませんでした。",
      breadcrumbs: '<a href="' + topUrl() + '">買取相場ガイド</a> ／ Not Found',
      heroEyebrow: "Not Found",
      heroTitle: "ページが見つかりません",
      heroLead: "指定された相場ページは存在しないか、URL が変更されています。",
      updated: "",
      body: [
        '<div class="ka-wrap">',
        '<div class="ka-empty">URL を確認するか、トップページから探し直してください。</div>',
        '<a class="ka-back-link" href="' + topUrl() + '">トレカ買取目安相場表 TOP</a>',
        "</div>"
      ].join("")
    });
  }

  function render() {
    var parsed = parseHandle();
    if (parsed.level === "l1") {
      topView();
      return;
    }

    if (parsed.level === "l2" && parsed.title) {
      titleView(parsed.title);
      return;
    }

    if (parsed.level === "l3" && parsed.title && parsed.packSlug) {
      packView(parsed.title, parsed.packSlug);
      return;
    }

    notFoundView();
  }

  render();
})();
